var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gmaps-map',{staticStyle:{"height":"1000px"},attrs:{"options":_vm.mapOptions}},[(_vm.loadReady)?_c('gmaps-heatmap',{attrs:{"items":_vm.locations,"maxIntensity":20}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }